import styles from './index.module.less'
import IMG_qwzyzl from '@/assets/image/gea/country/qwzyzl.svg'
import IMG_agszl from '@/assets/image/gea/country/agszl.svg'
import IMG_agezl from '@/assets/image/gea/country/agezl.svg'
import IMG_agdzl from '@/assets/image/gea/country/agdzl.svg'
import IMG_jkzl from '@/assets/image/gea/country/jkzl.svg'
import IMG_zydzs from '@/assets/image/gea/country/zydzs.svg'
import IMG_agsdz from '@/assets/image/gea/country/agsdz.svg'
import IMG_agedz from '@/assets/image/gea/country/agedz.svg'
import IMG_agddz from '@/assets/image/gea/country/agddz.svg'
import IMG_gagzl from '@/assets/image/gea/country/gagzl.svg'
import IMG_ltzl from '@/assets/image/gea/country/ltzl.svg'
import {
  StatisticNew_Response,
  StatisticNew_TreasureAmount,
  type I_StatsData,
} from '@/api/region/types'
import { useTranslation } from 'react-i18next'
import MeToolTip from '@/components/MeToolTip'
import earthIcon from '@/assets/image/gea/country/mainInfo/earth_icon.png'
import { useGlobalStore } from '@/hoxStore/globalStore'
import { formatDecimalCus, formatValue, ugagToGag, ugeaToGea2 } from '@/utils/number'
import { isEmptyOrNil } from '@/utils'
import math from '@/utils/math'
import { Tooltip } from 'antd'

function toThousands(num: number | string) {
  const number = typeof num === 'string' ? parseFloat(num) : num
  return isNaN(number) ? num : new Intl.NumberFormat().format(number)
}

const MainInfo = ({
  regionStatistic = null,
}: {
  regionStatistic: StatisticNew_Response | null
}) => {
  // regionStatistic?.staking_stats_by_region_aggregate?.aggregate?.sum
  // ?.total_fixed_address
  // regionStatistic?.staking_stats_by_region_aggregate?.aggregate?.sum
  // ?.total_delegation_address,
  // regionStatistic?.staking_stats_by_region_aggregate?.aggregate?.sum
  // ?.total_lock_up_address,
  // const getTotalAddress = () => {
  //   const total_fixed_address =
  //     regionStatistic?.staking_stats_by_region_aggregate?.aggregate?.sum?.total_fixed_address || 0
  //   const total_delegation_address =
  //     regionStatistic?.staking_stats_by_region_aggregate?.aggregate?.sum
  //       ?.total_delegation_address || 0
  //   const total_lock_up_address =
  //     regionStatistic?.staking_stats_by_region_aggregate?.aggregate?.sum?.total_lock_up_address || 0
  //   return formatValue(total_fixed_address + total_delegation_address + total_lock_up_address, true)
  // }
  const { t } = useTranslation()
  const { curReponsive } = useGlobalStore()
  // const getGAGTotal = () => {
  //   if (isEmptyOrNil(regionStatistic?.total_ans_count?.aggregate?.sum?.current_occupy_ans)) {
  //     return '-'
  //   }
  //   const value = math.multiply(
  //     regionStatistic?.total_ans_count?.aggregate?.sum?.current_occupy_ans,
  //     160000,
  //   )
  //   return toThousands(Math.trunc(parseFloat(value)))
  // }

  const getTreasureAmount = (val: StatisticNew_TreasureAmount[], denom: 'ugag' | 'ugea') => {
    if (!val.length) return ''
    if (denom === 'ugag') {
      return val.find((item) => item.denom === 'ugag')?.amount
    }
    return val.find((item) => item.denom === 'ugea')?.amount
  }
  return (
    <div className={styles.wrap}>
      <div className="wrap_item">
        <div className="item">
          <div className="item_left">
            <img src={IMG_qwzyzl} alt="" />
          </div>
          <div className="item_right">
            <div className="item_right_top">
              <span className="item_right_top_title">
                {/* 全网质押总量 */}
                {/* <MeToolTip title={t('explorer_41')} tip={t('explorer_132')}></MeToolTip> */}
                {/* GEA总量 */}
                {t('explorer_294')}
              </span>
              <span className="item_right_top_icon"></span>
            </div>
            <div className="item_right_bottom">
              {/* 固定写死：8,000,000,000 */}
              <Tooltip
                title={
                  // ugeaToGea2(
                  //   regionStatistic?.region_states_with_all_delegation_aggregate?.aggregate?.sum
                  //     .current_all_delegation_total_ugea,
                  // ).value

                  '8,000,000,000'
                }
              >
                <span className="item_right_bottom_content">
                  <span>
                    {
                      // ugeaToGea2(
                      //   regionStatistic?.region_states_with_all_delegation_aggregate?.aggregate?.sum
                      //     .current_all_delegation_total_ugea,
                      //   true,
                      // ).value
                      '8,000,000,000'
                    }
                  </span>
                  <span className="item_right_bottom_sign">
                    {
                      // ugeaToGea2(
                      //   regionStatistic?.region_states_with_all_delegation_aggregate?.aggregate?.sum
                      //     .current_all_delegation_total_ugea,
                      //   true,
                      // ).sigin
                      'GEA'
                    }
                  </span>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="item_left">
            <img src={IMG_agezl} alt="" />
          </div>
          <div className="item_right">
            <div className="item_right_top">
              <span className="item_right_top_title">
                {/* AGR锁定 */}
                <MeToolTip title={t('explorer_295')} tip={t('explorer_295_desc')}></MeToolTip>
              </span>
              <span className="item_right_top_icon"></span>
            </div>
            <div className="item_right_bottom">
              <Tooltip title={ugeaToGea2(regionStatistic?.agrAmount).value}>
                <span className="item_right_bottom_content">
                  <span>{ugeaToGea2(regionStatistic?.agrAmount, true).value}</span>
                  <span className="item_right_bottom_sign">
                    {ugeaToGea2(regionStatistic?.agrAmount, true).sigin}
                  </span>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      <div className="wrap_item">
        <div className="item">
          <div className="item_left">
            <img src={IMG_jkzl} alt="" />
          </div>
          <div className="item_right">
            <div className="item_right_top">
              <span className="item_right_top_title">
                {/* 金库总量 GEA */}
                <MeToolTip title={`${t('explorer_296')}`} tip={t('explorer_296_desc1')}></MeToolTip>
              </span>
              <span className="item_right_top_icon"></span>
            </div>
            <div className="item_right_bottom">
              <Tooltip
                title={
                  ugeaToGea2(getTreasureAmount(regionStatistic?.treasureAmount || [], 'ugea')).value
                }
              >
                <span className="item_right_bottom_content">
                  <span>
                    {
                      ugeaToGea2(
                        getTreasureAmount(regionStatistic?.treasureAmount || [], 'ugea'),
                        true,
                      ).value
                    }
                  </span>
                  <span className="item_right_bottom_sign">
                    {
                      ugeaToGea2(
                        getTreasureAmount(regionStatistic?.treasureAmount || [], 'ugea'),
                        true,
                      ).sigin
                    }
                  </span>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="item_left">
            <img src={IMG_jkzl} alt="" />
          </div>
          <div className="item_right">
            <div className="item_right_top">
              <span className="item_right_top_title">
                {/* 金库总量 GAG*/}
                <MeToolTip title={`${t('explorer_296')}`} tip={t('explorer_296_desc2')}></MeToolTip>
              </span>
              <span className="item_right_top_icon"></span>
            </div>

            <div className="item_right_bottom">
              <Tooltip
                title={
                  ugagToGag(getTreasureAmount(regionStatistic?.treasureAmount || [], 'ugag')).value
                }
              >
                <span className="item_right_bottom_content">
                  <span>
                    {
                      ugagToGag(
                        getTreasureAmount(regionStatistic?.treasureAmount || [], 'ugag'),
                        true,
                      ).value
                    }
                  </span>
                  <span className="item_right_bottom_sign">
                    {
                      ugagToGag(
                        getTreasureAmount(regionStatistic?.treasureAmount || [], 'ugag'),
                        true,
                      ).sigin
                    }
                  </span>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      <div className="wrap_item warp_item_earth_bg warp_item_earth_bgNew">
        {/* {curReponsive?.size !== 'mobile' ? (
          <div className="wrap_item_earth_icon">
            <img src={earthIcon} />
          </div>
        ) : null} */}
        <div className="item">
          <div className="item_left">
            <img src={IMG_gagzl} alt="" />
          </div>
          <div className="item_right">
            <div className="item_right_top">
              {/* 质押总量 */}
              <span className="item_right_top_title">
                <MeToolTip title={t('explorer_55')} tip={t('explorer_298')}></MeToolTip>
              </span>
              <span className="item_right_top_icon"></span>
            </div>
            <div className="item_right_bottom">
              <span className="item_right_bottom_content">
                <Tooltip title={ugeaToGea2(regionStatistic?.totalStakeAmount).value}>
                  <span className="item_right_bottom_content">
                    <span>{ugeaToGea2(regionStatistic?.totalStakeAmount, true).value}</span>
                    <span className="item_right_bottom_sign">
                      {ugeaToGea2(regionStatistic?.totalStakeAmount, true).sigin}
                    </span>
                  </span>
                </Tooltip>
              </span>
            </div>
          </div>
        </div>
        <div className="item">
          <div className="item_left">
            <img src={IMG_ltzl} alt="" />
          </div>
          <div className="item_right">
            <div className="item_right_top">
              <span className="item_right_top_title">
                {/* 流通总量 */}
                <MeToolTip title={t('explorer_297')} tip={t('explorer_297_desc')}></MeToolTip>
              </span>
              <span className="item_right_top_icon"></span>
            </div>
            <div className="item_right_bottom">
              <span className="item_right_bottom_content">
                <Tooltip title={ugeaToGea2(regionStatistic?.totalLiquidityAmount).value}>
                  <span className="item_right_bottom_content">
                    <span>{ugeaToGea2(regionStatistic?.totalLiquidityAmount, true).value}</span>
                    <span className="item_right_bottom_sign">
                      {ugeaToGea2(regionStatistic?.totalLiquidityAmount, true).sigin}
                    </span>
                  </span>
                </Tooltip>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainInfo
